import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_URL } from '../config.js';
import { toApiError } from '../lib/api-error';

interface UpdateTeardownParams {
  teardownWorkflowId?: string | null;
  teardownSnapshotVersion?: number | null;
  teardownEnabled?: boolean;
}

/** Mutation to update teardown configuration on a seed workflow. */
export function useUpdateTeardownWorkflow(seedWorkflowId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateTeardownParams) => {
      const res = await fetch(`${API_URL}/workflows/${seedWorkflowId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(params),
      });
      if (!res.ok) throw await toApiError(res, 'Failed to update teardown workflow');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['workflows'] });
    },
  });
}
